import { z } from 'zod';

export const CookieMutatedDTO = z.object({
    cookieMutated: z.boolean(),
});

export type CookieMutatedDTO = z.infer<typeof CookieMutatedDTO>;
